/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { PeriodsContext } from '../contexts';

export const usePeriodsStore = () => useContext(PeriodsContext);
